module.exports = __webpack_public_path__ + "img/2.08bf4a13.png";